import React, {useState, useEffect} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faRedo} from '@fortawesome/pro-duotone-svg-icons';
import {Form, Row,Col, Input, Button, Drawer, AutoComplete, Divider} from 'antd';
import {Estoque} from '../../../componentes';
import {useProdutos} from '../../../hooks/useProdutos';


const FormAddProdutoConferencia = ({visible, onClose, dataReferencia,onFinish}) => {

    const [produto, setProduto] = useState({});
    const [produtosDb, setProdutosDb] = useState([]);
    const [produtosCache, setProdutosCache] = useState([]);
    const [options, setOptions] = useState([]);
    
    const [form] = Form.useForm();
        

    const {listarProdutosEstoque} = useProdutos();

    useEffect(() => {
        lerProdutos(true);  
        // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [dataReferencia]);

    const lerProdutos = async (force) => {
        let produtos = produtosDb;
        if(produtos.length === 0 || force) {
            produtos = await listarProdutosEstoque("", dataReferencia.format("YYYY-MM-DD"));
            setProdutosDb(produtos);
        } 
        setProdutosCache(produtos);
        

    }

    const onFilter = (force) => async value => {
        if(force){
            await lerProdutos(force);
        }

        const produtos = produtosCache;

        const produtosAutoComplete = produtos.filter(produto => (
            produto.codigo.toUpperCase().indexOf(value.toUpperCase()) >=0 ||
            produto.descricao.toUpperCase().indexOf(value.toUpperCase()) >=0 ||
            produto.ncm === value
        ));

        const options = produtosAutoComplete.map(p => {
            return {
                key: p.uuid,
                produto: p,
                value: p.uuid,                
                label: (<div>{p.descricao}</div>)
            }
        });

        console.log("options", options);
        setOptions(options);

    }

    
    const onSelect = (value, item) => {
        
        form.setFieldsValue({
            produto: item.produto.descricao,
            quantidadeConferida: item.produto.saldoEstoque,
            diferenca:0,
            saldoEstoqueAtual: item.produto.saldoEstoque
            
        });

        setProduto(item.produto)
        
    }

    const changeQtdConferida = (evt) => {

        form.setFieldsValue({diferenca: ( (evt.floatValue) - produto.saldoEstoque)});
        
    }

    const adicionarConferencia = (values) => {
        if(produto.uuid){
            const {quantidadeConferida, saldoEstoqueAtual, diferenca} = values;
            onFinish({produto,quantidadeConferida, saldoEstoqueAtual, diferenca});
            form.resetFields();
            setProduto({});
        } else {
            alert("Nenhum produto informado"); 
        }
    }
    
    return (
        <Form layout="vertical" onFinish={adicionarConferencia}  onFinishFailed={(a)=> console.log(a)} form={form} style={{textAlign: 'right'}}>
            <Drawer 
                visible={visible} 
                onClose={onClose} 
                width={400}
                
                footer={<div style={{textAlign: 'right'}}>
                    <Button type="link" onClick={()=>{onClose()}}>Cancelar</Button>
                    
                    <Button htmlType="submit" type="primary" onClick={() => form.submit()}>Adicionar</Button>
                    
                </div>}
            >
                <Row>
                    <h2>Item para coferência</h2>
                </Row>
            
                <Row style={{textAlign: 'right'}}>

                
                    {(() => {
                        if(produto.uuid === undefined){
                            return (
                                <Form.Item
                                    name='produto'
                                    key='produto_key'
                                    label="Produto"                                    
                                >
                                    <AutoComplete
                                        onSearch={onFilter(false)}
                                        options={options}
                                        onSelect={onSelect}
                                        
                                    
                                        
                                        
                                    >

                                        <Input.Search  placeholder="Informe seu produto" enterButton={
                                                <FontAwesomeIcon icon={faRedo}></FontAwesomeIcon>
                                            }  onSearch={onFilter(true)} />
                                    </AutoComplete>
                                </Form.Item>
                            );
                        } else{

                            return (<>
                                <Col span={24} style={{textAlign: 'left'}}>
                                    <Form.Item>
                                        <h3>
                                            {produto.codigo} {produto.descricao} 
                                            <Button type="link" size="small" onClick={()=> {form.resetFields(); setProduto({})}}>[trocar]</Button>
                                        </h3>
                                    </Form.Item>
                                </Col>


                                <Col span={24}>


                                    <Form.Item
                                        name='quantidadeConferida'
                                        key='quantidadeConferida'
                                        label="Qtd Conferida"
                                        initialValue={produto.saldoEstoque}
                                        rules={[{
                                            required: true
                                        }]}
                                        
                                        
                                    >
                                        <Estoque 
                                                style={{textAlign: 'right'}}
                                                displayType="input" 
                                                customInput={Input} 
                                                type="text" 
                                                onValueChange={changeQtdConferida}
                                                suffix={" " + (produto.uCom || "")}
                                            />
                                        
                                    </Form.Item>
                                </Col>



                                <Divider></Divider>
                                <Col span={24}>


                                    <Form.Item
                                        
                                        name='saldoEstoqueAtual'
                                        key='saldoEstoqueAtual'
                                        label="Em Estoque"
                                        initialValue={produto.saldoEstoque}
                                        value={produto.saldoEstoque}
                                        >
                                            <Estoque 
                                                type="text" 
                                                suffix={" " + (produto.uCom || "")}
                                            />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>

                                    <Form.Item
                                        name='diferenca'
                                        key='diferenca'
                                        label="Ajuste"
                                        
                                        >
                                            <Estoque 
                                                type="text" 
                                                value={(produto.saldoEstoque - form.qtdEstoqueConferido)}                        
                                                suffix={" " + (produto.uCom || "")}
                                            />
                                    </Form.Item>
                                </Col>

                            </>)
                        }
                        
                        
                    })()}
                    


                    
                    </Row>
                
                
    
        </Drawer>
    </Form>);
}

export {FormAddProdutoConferencia};